import React from "react";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

const BasicBar = (props) => {
    return(
        <AppBar style={{backgroundColor: '#1d82e6'}} position="static">
            <Toolbar>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <img src={require('../../assets/imgs/ks_logo_white.png')} style={{marginRight: '30px'}} width={28} alt={'Koala Software'} />
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        OrderSys
                    </Typography>
                </div>
            </Toolbar>
        </AppBar>
    );
}
export default BasicBar